<template>
  <div class="login" :class="{ 'dark-mode': darkMode }">
    <ValidationObserver tag="div" class="form" ref="form" v-slot="{ passes }">
      <form @submit.prevent="passes(login)">
        <h3>Acesse sua conta</h3>

        <input-field
          label="Usuário"
          refName="username"
          class="input-field"
          placeholder="Digite seu usuário"
          rules="required"
          :isDisabled="hasRequest"
          :darkMode="darkMode"
          v-model="data.username"
        />

        <input-field
          label="Senha"
          placeholder="Digite sua senha"
          rules="required"
          :isDisabled="hasRequest"
          :darkMode="darkMode"
          v-model="data.password"
          type="password"
        />

        <button-component
          text="Acessar"
          styles="primary"
          class="button-component"
          size="large"
          v-ripple="'rgba(255, 255, 255, 0.35)'"
          :hasLoader="hasRequest"
          :isDisabled="hasRequest"
          :darkMode="darkMode"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Button from '@/components/pos/Button';
import InputField from '@/components/pos/InputField';
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'LoginPOSPage',

  data() {
    return {
      data: {
        username: '',
        password: '',
      },

      hasError: false,
      hasRequest: false,
      darkMode: false,
      externalAuthSuccess: false,
      externalAuthError: false,
      routeParams: null,
      query: null,
    };
  },

  components: {
    ValidationObserver,
    'button-component': Button,
    'input-field': InputField,
  },

  created() {
    var token = this.$route.query.token;
    var username = this.$route.query.username;
    var referenceId = this.$route.query.reference_id;

    var name = this.$route.query.name;
    var phone = this.$route.query.phone;
    var email = this.$route.query.email;
    var taxpayerId = this.$route.query.taxpayerId;
    var postalCode = this.$route.query.postalCode;
    var isResponsible = this.$route.query.isResponsible;
    var franchiseId = this.$route.query.franchiseId;
    var studentName = this.$route.query.studentName;
    var studentTaxpayerId = this.$route.query.studentTaxpayerId;
    var darkMode = this.$route.query.darkMode;

    this.darkMode = this.$service.stringToBoolean(darkMode);

    if (token && username) {
      this.$store
        .dispatch('authModule/setAuth', { token, username })
        .then(() => {
          this.$store.commit(
            'setCollaboratorId',
            this.$service.removeSpecialCharacter(username)
          );

          this.externalAuthSuccess = true;
          this.routeParams = {
            fistExternalLogin: true,
            referenceId: referenceId ?? '',
            name: name ?? '',
            email: email ?? '',
            phone: phone ?? '',
            taxpayerId: taxpayerId ?? '',
            postalCode: postalCode ?? '',
            franchiseId: franchiseId ?? '',
            isResponsible: isResponsible ?? false,
            studentName: studentName ?? '',
            studentTaxpayerId: studentTaxpayerId ?? '',
          };
          this.query = {
            darkMode: darkMode ?? false,
          };
        })
        .catch(() => {
          this.$store.dispatch('logout');
          this.externalAuthError = true;
        });
    }
  },

  mounted() {
    if (!this.$route.query.pos) {
      this.$router.replace({
        name: 'loginPOS',
        query: {
          ...this.$route.query,
          pos: 'true',
        },
      });
    }

    setTimeout(() => {
      try {
        this.$androidService.sendMessage('im-contract-loaded-successfully', {
          screen: 'loginPOS',
          readyForInput: true,
          darkMode: this.darkMode,
        });
      } catch (error) {
        // Falha silenciosa em evento de telemetria
      }
    }, 300);

    if (this.externalAuthSuccess) {
      this.$router.push({
        name: 'new',
        params: this.routeParams,
        query: this.query,
      });
    }
  },

  methods: {
    async login() {
      var isAuthenticated = false;

      this.hasRequest = true;

      await this.$store
        .dispatch('authModule/postLogin', this.data)
        .then(() => {
          isAuthenticated = true;
        })
        .catch(() => {
          if (this.$refs.form) {
            this.$refs.form.setErrors({
              username: 'Usuário ou senha inválido',
            });
          }
        });

      if (isAuthenticated) {
        localStorage.setItem('username', this.data.username);

        setTimeout(() => {
          try {
            this.$androidService.sendMessage('im-user-logged-in', {
              username: this.data.username,
              collaboratorId: this.$service.removeSpecialCharacter(
                this.data.username
              ),
              loginTimestamp: new Date().toISOString(),
              darkMode: this.darkMode,
            });
          } catch (error) {
            // Falha silenciosa em evento de telemetria
          }
        }, 100);

        await this.$store
          .dispatch('getFranchise', {
            login: this.data.username,
            limit_items: 5000,
          })
          .then(() => {
            setTimeout(() => {
              try {
                this.$androidService.sendMessage(
                  'im-navigate-to-new-contract',
                  {
                    screen: 'newPOS',
                    darkMode: this.darkMode,
                  }
                );
              } catch (error) {
                // Falha silenciosa em evento de telemetria
              }
            }, 100);

            this.$router.push({
              name: 'newPOS',
              params: {},
              query: {
                darkMode: this.darkMode,
                pos: 'true',
              },
            });
          })
          .catch(() => {
            this.$router.push({
              name: 'loginPOS',
              query: {
                darkMode: this.darkMode,
                pos: 'true',
              },
            });
          });
      }

      this.hasRequest = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  transition: background-color 0.3s ease;
  padding: 1.2rem;
  overflow: hidden;

  /**
  * 
  * Não consegui de forma alguma fazer com que o fundo do login 
  * ocupasse toda a altura do webview na SmartPOS, então usei absolute --- IGNORE ---
  *
  */
  position: absolute;
  inset: 0;

  .form {
    color: #333;
    transition: color 0.3s ease;
    width: 100%;
    max-width: 100%;

    form {
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      display: flex;
      width: 100%;

      h3 {
        margin-bottom: 2rem;
        font-size: 1.25rem;
        font-weight: 600;
        color: #333;
        transition: color 0.3s ease;
      }

      .input-field {
        margin-bottom: 1.5rem;
        width: 100%;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .button-component {
        margin-top: 2rem;
        width: 100%;
      }
    }
  }

  &.dark-mode {
    .form {
      color: #e0e0e0;

      form h3 {
        color: #e0e0e0;
      }
    }
  }
}
</style>
